import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=a18b865a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=a18b865a&prod&lang=less&scoped=scoped"
import style1 from "./Main.vue?vue&type=style&index=1&id=a18b865a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18b865a",
  null
  
)

export default component.exports